export default __webpack_public_path__ + "static/media/goToBack.4450ae4d.svg";